<template>
  <div class="video-content">
    <h2 class="q-mb-lg">Media Library</h2>

    <q-inner-loading :showing="loading">
      <q-spinner-dots size="50px" color="primary" />
    </q-inner-loading>

    <div v-if="!loading" class="video-gallery">
      <div v-for="(video, index) in videos" :key="index" class="video-item q-mb-xl">
        <h3 class="q-mb-sm">{{ video.title }}</h3>
        <VideoPlayer :src="video.url" :poster="video.thumbnail" width="100%" height="auto" :options="{ responsive: true }" @ready="onPlayerReady" />
        <p class="q-mt-sm video-description">{{ video.description }}</p>
      </div>
    </div>

    <div v-if="!loading && videos.length === 0" class="empty-state">
      <q-icon name="movie" size="64px" color="grey-5" />
      <p>No videos available in your media library</p>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@views/VideoPlayer.vue';
import { ContentApi } from '@api/index';
import { setCookie } from '@utils/cookies';
import axios from 'axios';

export default {
  name: 'VideoContent',
  components: {
    VideoPlayer
  },
  data() {
    return {
      loading: true,
      videos: [
        {
          title: 'Platform Tutorial',
          description: 'Learn how to navigate and use the main features of our platform',
          url: 'https://example.com/videos/tutorial.mp4',
          thumbnail: 'https://example.com/thumbnails/tutorial.jpg'
        },
        {
          title: 'Account Setup Guide',
          description: 'Step-by-step instructions for setting up your account properly',
          url: 'https://example.com/videos/setup.mp4',
          thumbnail: 'https://example.com/thumbnails/setup.jpg'
        }
      ]
    };
  },
  created() {
    this.fetchSignedCookies();
  },
  methods: {
    async fetchSignedCookies() {
      try {
        this.loading = true;
        console.log('fetching signed cookies...');

        // Call the signed-cookies endpoint to set authentication cookies
        const { cookies } = await ContentApi.getSignedCookie();

        console.log('Received signed cookies:', cookies);
        //cookies = {CloudFront-Expires: 1746439282, CloudFront-Key-Pair-Id: 'KX0SRPF5UNKRG', CloudFront-Signature: 'stCwnFXT2JoxlcrIFA~~tVIz5gka5Zf9axRcul2aFSfrSG~vaO…ZEegYIpm92RUUYUZxyoBuB8HPfCBxcuDNE077B66gjoraBg__'}
        // Set the cookies in the browser

        // Note: You may need to adjust the cookie attributes based on your requirements
        for (const [key, value] of Object.entries(cookies)) {
          console.log(`Setting cookie: ${key} = ${value}`);
          setCookie({
            cookieName: key,
            cookieValue: value,
            expiration: new Date(Date.now() + 60 * 60 * 1000), // 1 hour expiration
            domain: '.app.flashy-staging.ae'
          });
        }

        // After cookies are set, we can load the videos
        await this.fetchVideos();

        this.loading = false;
      } catch (error) {
        console.error('Error fetching signed cookies:', error);
        this.$store.dispatch('notification/addErrorNotification', 'Failed to authenticate media access. Please try again.');
        this.loading = false;
      }
    },
    async fetchVideos() {
      // In a real application, you would fetch the videos data from your API
      // For now, we're just using the sample data

      // Example of how you might fetch videos:
      // try {
      //   const response = await axios.get('/v1/videos');
      //   this.videos = response.data.videos;
      // } catch (error) {
      //   console.error('Error fetching videos:', error);
      //   this.$store.dispatch(
      //     'notification/addErrorNotification',
      //     'Failed to load videos. Please try again.'
      //   );
      //   this.videos = [];
      // }

      try {
        const { videos } = await ContentApi.getVideos();
        this.videos = videos;
      } catch (error) {
        console.error('Error fetching videos:', error);
        this.$store.dispatch('notification/addErrorNotification', 'Failed to load videos. Please try again.');
        this.videos = [];
      }

      // Simulating API delay
      await new Promise(resolve => setTimeout(resolve, 500));
    },
    onPlayerReady(player) {
      console.log('Player ready', player);
    }
  }
};
</script>

<style lang="scss" scoped>
.video-content {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  min-height: 200px;
}

.video-gallery {
  display: flex;
  flex-direction: column;
}

.video-item {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.video-description {
  color: var(--main-text-color);
  font-size: 14px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  p {
    margin-top: 16px;
    color: var(--main-text-color);
    font-size: 16px;
  }
}
</style>
